import {
    dealForm
} from '@/utils/index';
import {
    Toast
} from 'vant';
import {
    forgetPass
} from '@/api/user'

export default {
    name: 'reset',
    data() {
        return {
            username: '',
            password: '',
            form: {
                realname: '',
                username: '',
                password: '',
            },
            repeatPWD: '',
        }
    },

    methods: {

        onSubmit(values) {
            console.log('submit', values);
            const that = this;
            if(that.form.password != that.repeatPWD) {
                Toast.fail({
                    message: '两次输入的密码不一致！',
                    forbidClick: true,
                    onClose: () => {
                        that.form.password = ''
                        that.repeatPWD = ''
                    }
                })
                return false
            }
            let fd = dealForm(that.form);
            Toast.loading({
                message: '加载中...',
                forbidClick: true,
                duration: 0
            })

            forgetPass(fd).then(res => {
                console.log(res);
                    Toast.clear()
                    Toast.success({
                        message: res.msg,
                        forbidClick: true,
                        // duration: 1000,
                        onClose: () => {

                                that.$router.replace('/sign')
                            
                        }
                    });
                
            }).catch(rej => {
                console.log(rej);
                Toast.clear()
                Toast.fail({
                    message: rej.msg,
                    forbidClick: true,
                    onClose: () => {
                        that.form = {
                            realname: '',
                            username: '',
                            password: '',
                        }
                        that.repeatPWD = ''
                    }
                });
            })
          },

    },

    mounted() {
        const that = this;

    }
}